export default __webpack_public_path__ + "static/media/wind.a7891f0a.svg";